import { AssessmentType } from "../../../api/main/models/codeOnly/AssessmentType";
import { StartAssessmentBase } from "../StartAssessmentBase";

/**
 * Start an assessment session.
 */
export const StartAssessment = () => (<StartAssessmentBase defaultAssessmentType={AssessmentType.Assessment} />);
